export const brokerManaged = 'BROKER MANAGED';
export const direct = 'DIRECT';
export const unknown = 'UNKNOWN';

export const channelValues = [brokerManaged, direct, unknown];
